import styled from 'styled-components';

// Disclosure-specific page layout — the same grid suit uses
// (`suit/src/pages/disclosure/disclosure.styles.tsx`): a full-width
// header row, a 239px sidebar + 1fr body row, and a sticky footer row
// for the save bar. The one deviation from suit is height: square mounts
// the disclosure page inside the app shell's `<Frame>` (the shared outer
// layout), so the grid fills the frame (`min-height: 100%`) rather than
// the viewport (`100vh`) — otherwise the toolbar's height would push it
// past the frame and produce a scrollbar.
const DisclosureContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 239px 1fr;
  min-height: 100%;
`;

const FullWidthSection = styled.div`
  grid-column: 1 / -1;
`;

const SidebarCell = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

const BodyCell = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

const FooterCell = styled.div`
  grid-column: 1 / -1;
  position: sticky;
  bottom: 0;
  display: flex;
`;

export {
  DisclosureContainer,
  FullWidthSection,
  SidebarCell,
  BodyCell,
  FooterCell,
};
